import {helpers} from 'vuelidate/lib/validators'

// validator for hexadecimal values
export const hex = helpers.regex ('hex', /^[A-Fa-f0-9]+$/)
